import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import history from './history';
//
import App from './App';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <HistoryRouter history={history}>
      <Suspense>
        <App />
      </Suspense>
    </HistoryRouter>
  </HelmetProvider>
);
